import type { Product } from './api'

/**
 * Можно ли положить товар в корзину одним нажатием.
 *
 * Рецептурный — нельзя: его выдают в аптеке по рецепту (R-11). Того, чего нет
 * в аптеках, — тоже: такой заказ никто не соберёт.
 */
export function canAddToCart(product: Product): boolean {
  return !product.rx && product.inStock
}

/** Кэшбэк за покупку этого товара, сум. Процент считает сервер (R-12). */
export function cashbackFor(product: Product, quantity = 1): number {
  return Math.round((product.price * quantity * product.cb) / 100)
}

/**
 * Есть ли что показать в «Инструкции». У новых товаров все поля пустые —
 * тогда блока нет совсем: одна оговорка «носит справочный характер» без
 * самой инструкции выглядит как сломанная страница.
 */
export function hasInstruction(product: Product): boolean {
  const { indications, contra, dosage, storage } = product.texts
  return [indications, contra, dosage, storage].some((text) => text.trim() !== '')
}
